import HttpClient from "./HttpClient";

class TransactionRepository {
  private http = HttpClient.getInstance();

  async transactions(authBasic: string): Promise<any> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.http.get(
          "api/v1/documents/associates/transactions",
          {
            headers: {
              Authorization: `Basic ${authBasic}`,
              "Content-Type": "application/json",
            },
          }
        );
        resolve(response);
      } catch (error) {
        console.error("Error al obtener transacciones: ", error);
        reject(error);
      }
    });
  }
}
export default new TransactionRepository();
